module.exports = __webpack_public_path__ + "img/2.d3c45070.png";